export default __webpack_public_path__ + "static/media/responsive_connbecting_with_ṇand_celebrating_your_culture.8da05829.webp";